<div class="justify-center w-full bg-gray-50 h-full py-12">
    <div class="text-3xl lg:text-4xl text-center font-semibold">
        Our Fibre Partners
    </div>
    <div id="partners" class="justify-center">
        <div *ngFor="let item of partnerLogos">
 <img [src]="item.url" alt="{{item.alternativeText}}" class="px-3 lg:px-6 hover:cursor-pointer" loading="lazy" (click)=" router.navigateByUrl('/products/fibre')" width="100" height="auto">
        </div>
    </div>
    <div class="md:m-8 max-sm:mt-8 text-center text-base md:px-64">
        <b>Please note:</b> Not all providers are available in every location. It is recommended to do a coverage check for more information on availability.
    </div>
    <div class="text-center">
        <button class="fuse-mat-button-large text-xl mt-6 font-bold" mat-flat-button [color]="'accent'" (click)="checkCoverage()" routerLink="/">
            Check coverage 
        </button>
    </div>
</div>
